import React from 'react';
import { Placeholder, Youtube, Vimeo, Soundcloud } from './players';

var Player = function Player(_ref) {
  var player = _ref.player,
      codigo = _ref.codigo;

  switch (player) {
    case 'youtube':
      return React.createElement(Youtube, {
        codigo: codigo
      });

    case 'vimeo':
      return React.createElement(Vimeo, {
        codigo: codigo
      });

    case 'soundcloud':
      return React.createElement(Soundcloud, {
        codigo: codigo
      });

    default:
      return React.createElement(Placeholder, null);
  }
};

export default Player;